export default "__VITE_ASSET__CeznEaxX__"